<script setup lang="ts">
import { DentalAndVisionApplicant } from '@/application/shared/domain/DentalAndVisionApplicant';
import { RenderName, RenderDate, RenderEmail, RenderYesNoAnswer, RenderAddress, RenderPhone, RenderMedicareStatus, RenderMarriedStatus, RenderYesNoIcon, RenderSsn } from '@hfc/ui-core';

withDefaults(defineProps<{
  primaryApplicant: DentalAndVisionApplicant,
  iconsColor?: string,
  titleClass?: string,
}>(), {
  iconsColor: 'text-blue-500',
  titleClass: 'text-sm font-medium'
});

</script>
<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 flex-col sm:flex-row pt-4 space-y-3 sm:space-y-0">
      <div class="flex-1 space-y-3">
        <div class="flex-1 font-bold ">
          <RenderName :first-name="primaryApplicant.first_name" :middle-name="primaryApplicant.middle_name" :last-name="primaryApplicant.last_name" :suffix="primaryApplicant.suffix" :icon-color="iconsColor" />
        </div>
        <div class="flex-1">
          <RenderDate :date="primaryApplicant.date_of_birth" :icon-color="iconsColor" />, <span class="capitalize">{{ primaryApplicant.gender }}</span>
        </div>
        <div class="flex-1">
          <RenderSsn v-if="primaryApplicant.ssn" :ssn="primaryApplicant.ssn.toString()" icon-class="mr-2 text-gray-400" show-obfuscation-toggle obfuscation-toggle-class="text-sm text-blue-500" obfuscate />
        </div>
        <div>
          <RenderAddress
            :line-one="primaryApplicant.main_address?.line_one"
            :line-two="primaryApplicant.main_address?.line_two"
            :city="primaryApplicant.main_address?.city"
            :state="primaryApplicant.main_address?.state"
            :zip="primaryApplicant.main_address?.zip_code"
            :county="primaryApplicant.main_address?.county"
            :icon-color="iconsColor"
            :two-lines="true"
          />
        </div>
      </div>
      <div class="flex-1 space-y-2">
        <div v-if="primaryApplicant.is_mailing_same_as_main" class="flex flex-1">
          <RenderYesNoAnswer :question="'Mailing address same as home?'" :answer="primaryApplicant.is_mailing_same_as_main"  :title-class="titleClass"/>
        </div>
        <div v-else class="flex-1">
          <span class="text-sm mr-4" :class="titleClass">Mailing address:</span>
          <br>
          <RenderAddress
            :line-one="primaryApplicant.mailing_address?.line_one"
            :line-two="primaryApplicant.mailing_address?.line_two"
            :city="primaryApplicant.mailing_address?.city"
            :state="primaryApplicant.mailing_address?.state"
            :zip="primaryApplicant.mailing_address?.zip_code"
            :county="primaryApplicant.mailing_address?.county"
            :two-lines="true"
            :icon-color="iconsColor"
          />
        </div>
      </div>
      <div class="flex-1">
        <span class="text-sm mr-4" :class="titleClass">Medicare status</span>
        <br>
        <RenderMedicareStatus v-if="primaryApplicant.eligible_medicare" :status="primaryApplicant.eligible_medicare" />
      </div>
    </div>
    <div class="flex flex-1 flex-col sm:flex-row pt-4 space-y-3 sm:space-y-0">
      <div class="flex-1 space-y-3">
        <div>
          <RenderPhone v-if="primaryApplicant.phone" :phone="primaryApplicant.phone.number.toString()" :icon-color="iconsColor" />
        </div>
        <div class="flex-1">
          <RenderEmail v-if="primaryApplicant.email" :email="primaryApplicant.email" :icon-color="iconsColor" />
        </div>
      </div>
      <div class="flex-1">
        <span class="text-sm mr-4" :class="titleClass">Married Status:</span>
        <br>
        <RenderMarriedStatus v-if="primaryApplicant.marital_status" :status="primaryApplicant.marital_status" />
      </div>
      <div class="flex flex-1 align-center">
        <RenderYesNoIcon :boolean="primaryApplicant.is_english_first_language" :text="'English'" />
      </div>
    </div>
  </div>
</template>
